// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HeartIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M22.25 4C19.669 4 17.409 5.11 16 6.986 14.591 5.11 12.331 4 9.75 4A7.759 7.759 0 0 0 2 11.75c0 8.75 12.974 15.832 13.526 16.125a1 1 0 0 0 .948 0C17.026 27.582 30 20.5 30 11.75A7.759 7.759 0 0 0 22.25 4ZM16 25.85c-2.283-1.33-12-7.389-12-14.1A5.757 5.757 0 0 1 9.75 6c2.431 0 4.473 1.295 5.325 3.375a1 1 0 0 0 1.85 0C17.777 7.291 19.819 6 22.25 6A5.757 5.757 0 0 1 28 11.75c0 6.701-9.72 12.769-12 14.1Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
